"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "drenchia": {
    "34e8ce1a": [{
      "hkey": "4394222c",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "skipSearch": false
    }],
    "drenchia-inferiore": [{
      "hkey": "4394222c",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2ba7d599": [{
      "hkey": "4394222c",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "skipSearch": false
    }],
    "drenchia-superiore": [{
      "hkey": "4394222c",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "drenchia"
    }],
    "b9a6664d": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "skipSearch": false
    }],
    "malinsche": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7653bccc": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "skipSearch": false
    }],
    "obranche": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce00d27b": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "skipSearch": false
    }],
    "san-volfango": [{
      "hkey": "62511689",
      "slug": "drenchia",
      "name": "Drenchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;